export enum FOOTER_NAVIGATION_MENUS {
  ABOUT_US = 'About Us',
  CONTACT_US = 'Contact Us',
  HELP = 'Help',
  COOKIES = 'Cookies',
  PRIVACY = 'Privacy',
  TERMS_CONDITIONS = 'Terms & Conditions'
}
